/* eslint-disable no-restricted-globals */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';

import PropTypes from 'prop-types';

// HELPERS
import Chart from 'react-apexcharts';

// GRAPH CONFIGS
import { lineGraphOptions } from './options';

// COMPONENTS
import Loader from '../Loader/Loader';

// HELPERS
import { capitalize } from '../../util/util';

import styles from './Graph.module.scss';

const shareIcon = require('./imgs/share-icon.svg');

class Graph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chosenIndex: null,
      labelX: undefined,
      selectedIndex: null,
    };
  }

  /**
   * Checks if any value in argumento object array has .total
   * @param {Object Array} objectArray
   */
  hasTotal = (objectArray) =>
    objectArray.filter((e) => e.title === 'Total').length > 0;

  handleIndexColors = (tableData) => {
    const activeArray = [];
    const baseDefault = '#E5E5E5';
    const { colors } = lineGraphOptions;
    colors.forEach((color, index) => {
      const { chosenIndex } = this.state;
      activeArray[index] =
        (this.hasTotal(tableData) ? chosenIndex - 1 : chosenIndex) === index
          ? colors[index]
          : baseDefault;
    });
    return activeArray;
  };

  returnDiscreteArray = () => {
    const { seriesData, tableData } = this.props;
    const { chosenIndex } = this.state;
    const { colors } = lineGraphOptions;

    const discreteArray = [];
    if (seriesData) {
      seriesData.forEach(({ data }) => {
        data.forEach((item, index) => {
          discreteArray.push({
            seriesIndex: this.hasTotal(tableData)
              ? chosenIndex - 1
              : chosenIndex,
            dataPointIndex: index,
            fillColor: '#FFF',
            strokeColor:
              colors[this.hasTotal(tableData) ? chosenIndex - 1 : chosenIndex],
            size: 5,
          });
        });
      });
    }
    return discreteArray;
  };

  returnDiscreteArray = () => {
    const { seriesData, tableData } = this.props;
    const { chosenIndex } = this.state;
    const { colors } = lineGraphOptions;

    const discreteArray = [];
    if (seriesData) {
      seriesData.forEach(({ data }) => {
        data.forEach((item, index) => {
          discreteArray.push({
            seriesIndex: this.hasTotal(tableData)
              ? chosenIndex - 1
              : chosenIndex,
            dataPointIndex: index,
            fillColor: '#FFF',
            strokeColor:
              colors[this.hasTotal(tableData) ? chosenIndex - 1 : chosenIndex],
            size: 5,
          });
        });
      });
    }
    return discreteArray;
  };

  /**
   * Format label range
   * @param {String} range
   */
  formatLabelRange = (range) => {
    if(range && range.split(" - ")[0].length > 0){
      const splitRange = range.split(" - ");
      const leftRange = splitRange[0].split(" ")[1] ? splitRange[0].split(" ")[1].replace(/\D/g,'') : null
      return `${leftRange} - ${splitRange[1]}`;
    }
    return range;
  } 

  render() {
    const {
      firstColumn,
      secondColumnPrimary,
      secondColumnSecondary,
      thirdColumnPrimary,
      thirdColumnSecondary,
      seriesData,
      tableData,
      upperBound,
      onDataClick,
      dateRange,
      dateRangeType,
      onShare,
      isLoading,
    } = this.props;
    const {
      chosenIndex,
      shareX,
      shareY,
      labelX,
      labelWeek,
      labelRange,
      selectedIndex,
    } = this.state;
    const component = this;
    let pickedIndex = 0;

    if (selectedIndex === null || selectedIndex === undefined) {
      if (tableData) {
        pickedIndex = tableData.length - 1;
      }
    } else {
      pickedIndex = selectedIndex;
    }

    return (
      <div className={styles.graphWrapper}>
        <div className={styles.upperBoundContainer}>
          <p>{upperBound}</p>
        </div>
        <div className={styles.graphContainer}>
          {/* LOADER */}
          {isLoading ? (
            <div className={styles.loaderWrapper}>
              <Loader />
            </div>
          ) : null}
          {/* X LABEL */}
          {labelX !== undefined && !isNaN(labelX)? (
            <div
              style={{ left: labelX }}
              className={[
                styles.xLabel,
                labelWeek === 1 || labelWeek === 2 ? styles.leftRange : null,
                labelWeek === 8 ||
                labelWeek === 9 ||
                labelWeek === 10 ||
                labelWeek === 11 ||
                labelWeek === 12
                  ? styles.rightRange
                  : null,
              ].join(' ')}
            >
              <p>{`${dateRangeType === 'week' ? 'W' : 'M'}${labelWeek}`}</p>
              <span
                style={labelWeek === 8 || labelWeek === 9 ? { right: 58 } : null}
              >{this.formatLabelRange(labelRange)}
              </span>
            </div>
          ) : null}
          {/* SHARE ICON */}
          {shareX && shareY ? (
            <div
              onClick={onShare}
              style={{
                backgroundColor: lineGraphOptions.colors[0],
                left: shareX,
                top: shareY,
              }}
              className={styles.shareIcon}
            >
              <img alt='share' src={shareIcon} />
            </div>
          ) : null}
          <Chart
            series={seriesData}
            options={{
              ...lineGraphOptions,
              // Had to add date range into the options object so it can be in the "w" object in formatter on line 80
              // Looks like it doesn't read the global scope of the component (no this.state || this.props available)
              dateRange,
              dateRangeType,
              tooltip: {
                enabled: true,
                custom() {
                  return null;
                },
                x: {
                  formatter() {
                    // const hasData = w.config.dateRange.length > 0;
                    // const leftRange = (hasData && (index === 1 || index === 2))
                    // const rightRange = (hasData && ((index === (w.config.dateRange.length)) || (index === (w.config.dateRange.length) - 1)))
                    return '';
                    // return `
                    //   <div
                    //     style="position: relative; left: ${leftRange ? "30px" : "0px"}";
                    //     class='dateRange'
                    //   >
                    //     <p
                    //       style="position: relative; right: ${leftRange ? "30px" : "0px"}"
                    //     >
                    //         ${dateRangeType === 'week' ? 'W' : 'M'}${index}
                    //     </p>
                    //     <span
                    //       style="position: relative; left: ${(leftRange || rightRange) ? rightRange ? "-55px" : "25px" : "0"}"
                    //     >${
                    //       w.config.dateRange.length > 0 &&
                    //       w.config.dateRange[index - 1]
                    //         ? w.config.dateRange[index - 1]
                    //         : 'N/A'
                    //     }</span>
                    //   </div>
                    // `;
                  },
                },
              },
              colors:
                chosenIndex !== null
                  ? this.handleIndexColors(tableData)
                  : lineGraphOptions.colors,
              markers: {
                size: 5,
                strokeColors:
                  chosenIndex === null
                    ? ['#0D87A0', '#5AC0BE', '#9FE3CB', '#4F5A9E', '#916899']
                    : 'transparent',
                colors: chosenIndex === null ? ['#FFF'] : ['transparent'],
                hover: {
                  size: 7,
                },
                discrete:
                  chosenIndex !== null ? this.returnDiscreteArray() : [{}],
              },
              chart: {
                zoom: {
                  enabled: false,
                },
                toolbar: {
                  show: false,
                },
                events: {
                  mouseMove(event, ctx) {
                    if(event.type === 'touchmove' && seriesData && seriesData.length > 0) {
                      const { seriesXvalues } = ctx.w.globals;
                      const { clientX } = event.touches[0];
                      const target = clientX - 21;
                      const closest = seriesXvalues[0].sort(
                        (a, b) => Math.abs(target - a) - Math.abs(target - b)
                      )[0];
                      const sortedArray = seriesXvalues[0].sort(
                        (a, b) => a - b
                      );
                      component.setState({
                        selectedIndex: sortedArray.indexOf(closest),
                        labelX: seriesXvalues[0][sortedArray.indexOf(closest)],
                        labelRange:
                          ctx.w.config.dateRange[sortedArray.indexOf(closest)],
                        labelWeek: sortedArray.indexOf(closest) + 1,
                      });
                    }
                  },
                  markerClick(event, ctx, w) {
                    const { seriesXvalues } = ctx.w.globals;
                    const { dataPointIndex } = w;
                    component.setState({
                      selectedIndex: dataPointIndex,
                      labelX: seriesXvalues[0][dataPointIndex],
                      labelRange: ctx.w.config.dateRange[dataPointIndex],
                      labelWeek: dataPointIndex + 1,
                    });
                  },
                  mounted(ctx) {
                    if (ctx.w.globals.seriesXvalues[0]) {
                      const { seriesXvalues, seriesYvalues } = ctx.w.globals;
                      component.setState({
                        shareX: seriesXvalues[0][2] + 13,
                        shareY: seriesYvalues[0][2] - 10,
                        labelX: seriesXvalues[0][seriesXvalues[0].length - 1],
                        labelWeek: ctx.w.globals.series[0].length || 'N/A',
                      });
                    }
                  },
                  updated(ctx) {
                    if (ctx.w.globals.seriesXvalues[0]) {
                      const { seriesXvalues, seriesYvalues } = ctx.w.globals;
                      component.setState({
                        shareX: seriesXvalues[0][2] + 13,
                        shareY: seriesYvalues[0][2] - 10,
                        labelX: seriesXvalues[0][seriesXvalues[0].length - 1],
                        labelWeek: ctx.w.globals.series[0].length,
                        labelRange:
                          ctx.w.config.dateRange[
                            ctx.w.globals.series[0].length - 1
                          ] || 'N/A',
                      });
                    }
                  },
                },
              },
            }}
            width='97%'
          />
        </div>
        <div className={styles.detailsContainer}>
          {/* DETAILS HEADER */}
          <div className={styles.detailsHeader}>
            <div>
              <p>{firstColumn}</p>
            </div>
            <div>
              <div>
                <p>{secondColumnPrimary}</p>
                <p>{secondColumnSecondary}</p>
              </div>
              <div>
                <p>{thirdColumnPrimary}</p>
                <p>{thirdColumnSecondary}</p>
              </div>
            </div>
          </div>
          {/* DETAILS ROW ITEMS */}
          {tableData !== undefined &&
          tableData !== null &&
          tableData[pickedIndex] !== undefined &&
          tableData[pickedIndex] !== null &&
          tableData[pickedIndex].length > 0
            ? tableData[pickedIndex].map(
                ({ title, value, percentChange }, index) => {
                  const { colors } = lineGraphOptions;
                  const rangeColor = percentChange <= 0 ? '#E53935' : '#179F66';
                  const emptyRange = !percentChange || percentChange === 'N/A';
                  const isTotal = title === 'Total';
                  const isHighlighted = index === chosenIndex;
                  const itemColor = this.hasTotal(tableData)
                    ? colors[index - 1]
                    : colors[index];
                  const widthNormalizer = percentChange < 0 ? -0.5 : 0.5;
                  return (
                    <div
                      onTouchStart={
                        !isTotal
                          ? () => this.setState({ chosenIndex: index })
                          : null
                      }
                      onTouchEnd={
                        !isTotal
                          ? () => this.setState({ chosenIndex: null })
                          : null
                      }
                      key={title}
                      className={[
                        styles.detailsItem,
                        isTotal ? styles.totalsItem : null,
                        isHighlighted ? styles.highlighted : null,
                      ].join(' ')}
                    >
                      <div
                        onDoubleClick={() => {
                          onDataClick({
                            highlightColor: itemColor,
                            title,
                          });
                        }}
                        // onDoubleClick={() =>
                        //   this.setState({ touchStart: moment(new Date()) })
                        // }
                        // onDoubleClickCapture={() => {
                        //   const now = moment(new Date());
                        //   const duration = moment
                        //     .duration(now.diff(touchStart))
                        //     .asSeconds();
                        //   if (duration < 0.5 && !isTotal) {
                        //     onDataClick({
                        //       highlightColor: itemColor,
                        //       title,
                        //     });
                        //   }
                        // }}
                        className={styles.companyContainer}
                      >
                        {!isTotal ? (
                          <div style={{ backgroundColor: itemColor }} />
                        ) : null}
                        <p>{capitalize(title)}</p>
                      </div>

                      <div>
                        <div>
                          <p>{value}</p>
                        </div>
                        <div className={styles.rangeContainer}>
                          <p
                            className={emptyRange ? styles.noChange : null}
                            style={{ color: rangeColor }}
                          >
                            {emptyRange ? '-' : percentChange}
                          </p>
                          <div
                            style={{
                              width: !emptyRange
                                ? percentChange * widthNormalizer
                                : 0,
                            }}
                            className={[
                              styles.range,
                              percentChange < 0
                                ? styles.negative
                                : styles.positive,
                            ].join(' ')}
                          />
                          <svg>
                            <line
                              x1='0'
                              y1='0'
                              x2='0'
                              y2={isTotal ? '75' : '71'}
                              stroke='#E5E5E5'
                              strokeWidth='2'
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  );
                }
              )
            : ''}
        </div>
      </div>
    );
  }
}

Graph.propTypes = {
  seriesData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  tableData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  firstColumn: PropTypes.string.isRequired,
  secondColumnPrimary: PropTypes.string.isRequired,
  secondColumnSecondary: PropTypes.string.isRequired,
  thirdColumnPrimary: PropTypes.string.isRequired,
  thirdColumnSecondary: PropTypes.string.isRequired,
  upperBound: PropTypes.string.isRequired,
  onDataClick: PropTypes.func.isRequired,
  dateRange: PropTypes.arrayOf(PropTypes.string).isRequired,
  dateRangeType: PropTypes.string.isRequired,
  onShare: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

Graph.defaultProps = {
  isLoading: false,
};

export default Graph;
